import type { OfferPagePriceMode, OfferPageRoom } from 'contexts/OfferPage/offerPageStateReducer'
import { getPriceDisplayFunction } from 'lib/offer/offerPageUtil'
import getValueOffPercent from 'lib/offer/getValueOffPercent'
import type { MultiRoomPackageTotals } from 'selectors/offerPage/multipleRoomBookingSelectors'

interface Params {
  packageOption: App.OfferPackageOptionView
  priceMode: OfferPagePriceMode
  rooms: Array<OfferPageRoom>
  multiRoomPackageTotals?: MultiRoomPackageTotals
}

interface ValueComparisonPricing {
  price: number
  value: number
  discountPercent: number
}

function getResolvedPackagePricing(packageOption: App.OfferPackageOptionView) {
  return packageOption.memberPricing?.price ? packageOption.memberPricing : packageOption.pricing
}

export default function getFlashHotelValueComparisonPricing(params: Params): ValueComparisonPricing {
  const { packageOption, priceMode, rooms, multiRoomPackageTotals } = params
  const convertToDisplay = getPriceDisplayFunction(priceMode, rooms)
  const resolvedPricing = getResolvedPackagePricing(packageOption)

  if (multiRoomPackageTotals) {
    const price = convertToDisplay(
      multiRoomPackageTotals.hotelMemberPrice > 0 ?
        multiRoomPackageTotals.hotelMemberPrice :
        multiRoomPackageTotals.hotelPrice,
    )
    const value = convertToDisplay(multiRoomPackageTotals.hotelValue)

    return {
      price,
      value,
      discountPercent: getValueOffPercent(value, price),
    }
  }

  const price = convertToDisplay(resolvedPricing.price)
  const value = convertToDisplay(resolvedPricing.value)

  return {
    price,
    value,
    discountPercent: getValueOffPercent(value, price),
  }
}
